var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvironmentClimate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.159 19.0664C13.6901 19.8557 12.0394 20.2445 10.3726 20.1937C8.70592 20.1429 7.08193 19.6542 5.66388 18.7769C4.24583 17.8996 3.08368 16.6645 2.29424 15.1957C1.50479 13.7269 1.11586 12.0762 1.16653 10.4094C1.21719 8.7427 1.70568 7.11866 2.58288 5.70054C3.46008 4.28241 4.69511 3.12016 6.16383 2.33058C7.63255 1.54101 9.28322 1.15193 10.95 1.20245C12.6167 1.25297 14.2408 1.74131 15.659 2.61839",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.159 17.9764L22.159 3.69739C22.159 3.16695 21.9483 2.65825 21.5732 2.28317C21.1981 1.9081 20.6894 1.69739 20.159 1.69739C19.6286 1.69739 19.1199 1.9081 18.7448 2.28317C18.3697 2.65825 18.159 3.16695 18.159 3.69739L18.159 17.9764C17.7061 18.3814 17.3869 18.9144 17.2436 19.5049C17.1003 20.0953 17.1397 20.7153 17.3565 21.2829C17.5733 21.8505 17.9573 22.3389 18.4577 22.6834C18.9582 23.028 19.5514 23.2125 20.159 23.2125C20.7666 23.2125 21.3598 23.028 21.8603 22.6834C22.3607 22.3389 22.7447 21.8505 22.9615 21.2829C23.1783 20.7153 23.2177 20.0953 23.0744 19.5049C22.9311 18.9144 22.6119 18.3814 22.159 17.9764Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.159 7.19739L22.159 7.19739",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.659 11.6974L22.159 11.6974",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.659 15.6974L22.159 15.6974",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.659 9.69739L4.902 10.5084C5.11824 10.5626 5.31019 10.6874 5.44734 10.8632C5.58449 11.0389 5.65899 11.2555 5.659 11.4784L5.659 13.6974L6.694 15.0774C6.82712 15.2548 6.8975 15.4714 6.89406 15.6931C6.89062 15.9149 6.81356 16.1292 6.675 16.3024L5.159 18.1974",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.159 6.19739L11.982 7.28639C11.7579 7.3986 11.5841 7.59088 11.495 7.82516C11.4059 8.05943 11.408 8.31862 11.501 8.55139L11.908 9.56839C11.9821 9.75395 12.1101 9.91305 12.2755 10.0252C12.441 10.1373 12.6362 10.1973 12.836 10.1974L14.659 10.1974L15.659 12.1974",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.159 7.19739L5.937 6.35739C6.40294 6.25389 6.81651 5.98716 7.103 5.60539L7.588 4.95939C7.76651 4.72135 7.88967 4.44647 7.94849 4.1548C8.00731 3.86313 8.00031 3.56201 7.928 3.27339L7.659 2.19739",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.659 14.6974L14.096 15.4784C13.9596 15.5467 13.8407 15.6453 13.7484 15.7666C13.656 15.8879 13.5926 16.0288 13.563 16.1784L13.263 17.6784C13.2312 17.8393 13.2395 18.0055 13.2871 18.1625C13.3347 18.3194 13.4202 18.4623 13.536 18.5784L14.159 19.1974",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.158997 0.197388)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentClimate);
export default __webpack_public_path__ + "static/media/environment_climate.944298f3.svg";
export { ForwardRef as ReactComponent };